import i18n from 'shared/lib/i18n';

export const validateDeliveryCreation = (values) => {
  const errors = {};
  if (Number(values.type) === 7) {
    errors.comments = !values.comments ? i18n.t('errors.valueRequired') : null;
  }
  if (
    (!values.recipients || !values.recipients.length) &&
    (!values.units || !values.units.length)
  ) {
    errors.recipients = i18n.t('errors.recipientRequired');
    errors.units = i18n.t('errors.recipientRequired');
  }
  return errors;
};

export const getDeliveryTypeIcon = (deliveryTypes, deliveryTypeId) =>
  deliveryTypes?.find((dt) => Number(dt.id) === Number(deliveryTypeId))
    ?.icons?.[0]?.url;
